import { useState, useEffect, useRef } from "react";

import { API_URL, getValFromLS, setValToLS, scroll } from "../../helpers";

import useFetch from "../../useFetch";

import Alert from "../../components/Alert";
import Input from "../../components/Input";
import Msg from "../../components/Msg";
import Submit from "../../components/Submit";

import Buttons from "./Buttons";

import { faChevronCircleRight } from "@fortawesome/pro-light-svg-icons";

import S from "./styled";

const Order = ({ handleStatus }) => {
	const [url, setUrl] = useState(null);
	const [amounts, setAmounts] = useState([]);
	const [names, setNames] = useState({});
	const [errors, setErrors] = useState([]);
	const [msg, setMsg] = useState({});
	const [alert] = useState({});

	const { loading, data } = useFetch(url);
	const formElement = useRef(null);

	useEffect(() => {
		const newUrl = new URL(`${API_URL}/`);
		const params = {
			f: "donateInit",
			x: crypto.randomUUID(),
		};
		newUrl.search = new URLSearchParams(params);
		setUrl(newUrl);

		// eslint-disable-next-line
	}, []);

	useEffect(() => {
		if (data && data.resp === 1) {
			setAmounts([...data.amounts]); // ...data.amounts
		}
	}, [data]);

	useEffect(() => {
		if (!loading) {
			scroll();

			if (getValFromLS("order", true)) {
				const order = JSON.parse(getValFromLS("order", true));
				setNames((names) => ({ ...names, ...order.donor, ...order.mailing }));
			}
		}
	}, [loading]);

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/?f=donate`);
		let formData = new FormData(formElement.current);
		formData.append("amount", names.amount || "");

		try {
			const response = await fetch(url, {
				method: "POST",
				body: formData,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setValToLS(
					"order",
					JSON.stringify({
						amount: json.amount,
						donor: json.donor,
						mailing: json.mailing,
					}),
					true,
				);

				handleStatus(2);
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<>
			{loading || alert.type ? (
				<Alert
					data={
						loading
							? {
									type: "working",
									text: "",
							  }
							: alert
					}
				/>
			) : (
				<S.Grid>
					<S.LeftContainer></S.LeftContainer>

					<S.Container>
						<S.Details>
							<p className="lead">
								Funds raised benefit <b>The Lois Pope Pet Clinic</b> at Tri
								County Animal Rescue, South Florida youth through the Palm Beach
								County Food Bank’s <b>“Lois’ Food4Kids”</b> endeavor and{" "}
								<b>Lois’ Vision4Kids</b> program in partnership with Bascom
								Palmer Eye Institute.
							</p>

							{/*	removed 4/24/24 per Cara
								, and disabled veterans through the{" "}
								<b>“Pups4Patriots”</b> program at American Humane Society
							*/}

							<div>
								<div>
									<h3>The Lois Pope Pet Clinic</h3>
									<p>
										The Lois Pope Pet Clinic at Tri County Animal Rescue, where
										low-income families receive the highest-quality and
										comprehensive medical services and health care - from
										surgeries to diagnostic scans and tests, exams and medicines
										- for their dogs, cats, and other pets at little or no cost
										in the Lois Pope Pet Clinic, the only one of its kind in the
										entire Southeast Florida region.
									</p>
								</div>

								<div>
									<h3>Lois’ Food4Kids Program</h3>
									<p>
										“Lois’ Food4Kids” has been similarly life-changing. This
										year-round initiative provides underserved, disadvantaged
										children with nutritious meals when they are not in school,
										on weekends, during school holidays and in the summer. Since
										the program launched, more than 5,000 children have received
										backpacks filled with healthy foods on a weekly basis.
									</p>
								</div>

								<div>
									<h3>Lois’ Vision4Kids Program</h3>
									<p>
										Lois’ Vision4Kids is a program that offers free vision
										screenings and glasses to children aged 2-18 in Palm Beach
										County. The program works in partnership with the Bascom
										Palmer Eye Institute, which provides these services to
										schools and youth organizations. Since its launch in October
										2023, hundreds of children have already benefited from Lois’
										Vision4Kids.
									</p>
								</div>

								{/*	<div>
									<h3>Pups4Patriots Program</h3>
									<p>
										The “Pups4Patriots” program takes dogs languishing in
										shelters, provides them with specialized training, and then
										pairs them with disabled veterans suffering from
										Post-Traumatic Stress Disorder and traumatic brain injuries.
										To date, dozens of veterans have been given these
										life-transforming dogs, helping decrease the suicide rate
										among veterans.
									</p>
								</div>*/}
							</div>
						</S.Details>

						<S.Form
							method="post"
							action="/"
							onSubmit={(e) => handleSubmit(e)}
							ref={formElement}
						>
							<S.Hdg>
								<h4>
									Please select an amount and enter your information below to
									make a donation to Leaders In Furthering Education, Inc.
									(LIFE).
								</h4>
							</S.Hdg>

							<Buttons
								handleUpdate={handleUpdate}
								selected={names.amount}
								amounts={amounts}
							/>

							{names.amount === "other" && (
								<S.FormRow2>
									<Input
										name="otherAmount"
										label="Other Amount"
										reqd={true}
										autocomplete="off"
										update={handleUpdate}
										errors={errors}
									/>

									<div />
								</S.FormRow2>
							)}

							<S.Hdg>
								<h5>Donor Information</h5>
							</S.Hdg>

							<S.FormRow2>
								<Input
									name="fname"
									label="First Name"
									reqd={true}
									autocomplete="given-name"
									update={handleUpdate}
									errors={errors}
									value={names.fname || ""}
								/>

								<Input
									name="lname"
									label="Last Name"
									reqd={true}
									autocomplete="family-name"
									update={handleUpdate}
									errors={errors}
									value={names.lname || ""}
								/>
							</S.FormRow2>

							<S.FormRow2>
								<Input
									name="email"
									label="Email Address"
									reqd={true}
									autocomplete="email"
									update={handleUpdate}
									errors={errors}
									value={names.email || ""}
								/>

								<Input
									name="phone"
									label="Phone"
									reqd={true}
									autocomplete="tel"
									update={handleUpdate}
									errors={errors}
									value={names.phone || ""}
								/>
							</S.FormRow2>

							<S.Hdg>
								<h5>Mailing Address</h5>
							</S.Hdg>

							<S.FormRow2>
								<Input
									name="address"
									label="Address"
									reqd={true}
									autocomplete="address-line1"
									update={handleUpdate}
									errors={errors}
									value={names.address || ""}
								/>

								<Input
									name="address2"
									label="Address 2"
									reqd={false}
									autocomplete="address-line2"
									update={handleUpdate}
									errors={errors}
								/>
							</S.FormRow2>

							<S.FormRow3>
								<Input
									name="city"
									label="City"
									reqd={true}
									autocomplete="address-level2"
									update={handleUpdate}
									errors={errors}
									value={names.city || ""}
								/>

								<Input
									name="st"
									label="State (2-letter)"
									reqd={true}
									autocomplete="address-level1"
									update={handleUpdate}
									errors={errors}
									value={names.st || ""}
								/>

								<Input
									name="zip"
									label="Zip Code"
									reqd={true}
									autocomplete="postal-code"
									update={handleUpdate}
									errors={errors}
									value={names.zip || ""}
								/>
							</S.FormRow3>

							<S.FormMsgSubmit>
								{msg.type && <Msg data={msg} />}
								{msg.type !== "working" && (
									<Submit
										name="Continue to Payment"
										icon={faChevronCircleRight}
									/>
								)}
							</S.FormMsgSubmit>
						</S.Form>

						<p style={{ marginTop: "15px", textAlign: "center" }}>
							For additional information, please call (561) 582-8083 or email:{" "}
							<a href="mailto:life@life-edu.org">life@life-edu.org</a>.
						</p>
					</S.Container>
				</S.Grid>
			)}
		</>
	);
};

export default Order;
